import type { DocumentNamingOverride } from "./types";

import { TENANT_IDS } from "../../constants/tenantIds";
import { dominionEnergyNamingFormatHelpText, dominionEnergyNamingOverride } from "./dominionEnergy";

export type { DocumentNamingContext, DocumentNamingOverride } from "./types";

/**
 * Per-tenant document-title overrides. When a tenantId is in this map, the
 * override fully owns the title format and replaces the default
 * `formatDocumentName` output.
 *
 * Add a new tenant by creating a sibling file (see `dominionEnergy.ts`) and
 * registering its override + help text here.
 */
export const TENANT_DOCUMENT_NAMING_OVERRIDES: Record<string, DocumentNamingOverride> = {
  [TENANT_IDS.DOMINION_ENERGY]: dominionEnergyNamingOverride,
};

/**
 * Human-readable description of the standardized-filename format for a
 * given tenant. Shown in the upload modal so users know what their filename
 * will be rewritten to. Tenants without an override get the default
 * `DocumentType_FacilityName_Date.fileExtension` shape.
 */
const TENANT_NAMING_FORMAT_HELP_TEXT: Record<string, string> = {
  [TENANT_IDS.DOMINION_ENERGY]: dominionEnergyNamingFormatHelpText,
};

const DEFAULT_NAMING_FORMAT_HELP_TEXT = "DocumentType_FacilityName_Date.fileExtension";

export function getTenantNamingOverride(
  tenantId: string | null | undefined
): DocumentNamingOverride | undefined {
  if (!tenantId) return undefined;
  return TENANT_DOCUMENT_NAMING_OVERRIDES[tenantId];
}

export function getNamingFormatHelpText(tenantId: string | null | undefined): string {
  if (!tenantId) return DEFAULT_NAMING_FORMAT_HELP_TEXT;
  return TENANT_NAMING_FORMAT_HELP_TEXT[tenantId] ?? DEFAULT_NAMING_FORMAT_HELP_TEXT;
}
